import { useParams, Navigate } from 'react-router-dom';

import { FullScreenLoading } from '@backrs_ui/common-ui';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/appRoutes.constants';
import { usePageTitle } from '@backrs_ui/grow-ui/src/hooks/usePageTitle';
import { useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';
import {
  useGetMajorByIdQuery,
  useGetAllMajorsQuery,
} from '@backrs_ui/grow-ui/src/redux/major/major.api';

import { MajorPage } from './MajorPage';
import { useAgentContext } from './MajorsPageContainer.agentContext';

export const MajorsPageContainer = () => {
  const { majorId } = useParams();
  const careerPaths = useAppSelector((state) => state.careerPath.careerPaths);

  const { data: majors = [], isLoading: isLoadingMajors } = useGetAllMajorsQuery(undefined);

  // Call hook unconditionally, but skip query if no majorId
  const {
    data: major,
    isLoading: isLoadingMajor,
    isError,
  } = useGetMajorByIdQuery(majorId || '', {
    skip: !majorId,
  });

  const isLoading = isLoadingMajors || isLoadingMajor;

  usePageTitle(major?.name);
  useAgentContext(major);

  // Show loading state first, before checking for missing data
  if (isLoading) {
    return <FullScreenLoading />;
  }

  // Only redirect after loading completes and data is confirmed missing
  if (!majorId || isError || !major || !majors.length) {
    return <Navigate to={APP_ROUTE.MAJORS} replace />;
  }

  return <MajorPage major={major} careerPaths={careerPaths} />;
};
